import { render } from "./BrandKneippVerlag.vue?vue&type=template&id=3b9fec54"
import script from "./BrandKneippVerlag.vue?vue&type=script&lang=ts"
export * from "./BrandKneippVerlag.vue?vue&type=script&lang=ts"

import "./BrandKneippVerlag.vue?vue&type=style&index=0&id=3b9fec54&lang=scss"
script.render = render

export default script